var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEventsBlack = function SvgEventsBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "events-black_svg__Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.8 35.25"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".events-black_svg__cls-1,.events-black_svg__cls-2{fill:none;stroke:#000}.events-black_svg__cls-1{stroke-linecap:round;stroke-linejoin:round}.events-black_svg__cls-2{stroke-miterlimit:10}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "events-black_svg__Ebene_1-2",
    "data-name": "Ebene 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "events-black_svg__cls-1",
    d: "M10.05 5.29H5.28c-1.47 0-2.66 1.19-2.66 2.65v24.15c0 1.47 1.19 2.66 2.66 2.66h19.07M21.67 5.29h-8.65M27.32 34.75h2.1c1.47 0 2.66-1.19 2.66-2.66V7.95a2.65 2.65 0 0 0-2.66-2.65h-4.77"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "events-black_svg__cls-2",
    x: 23.64,
    y: 12.41,
    width: 5.63,
    height: 5.63,
    rx: 1.57,
    ry: 1.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "events-black_svg__cls-2",
    x: 14.7,
    y: 12.41,
    width: 5.63,
    height: 5.63,
    rx: 1.57,
    ry: 1.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "events-black_svg__cls-2",
    x: 5.76,
    y: 12.41,
    width: 5.63,
    height: 5.63,
    rx: 1.57,
    ry: 1.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "events-black_svg__cls-2",
    x: 23.49,
    y: 22.01,
    width: 5.63,
    height: 5.63,
    rx: 1.57,
    ry: 1.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "events-black_svg__cls-2",
    x: 14.56,
    y: 22.01,
    width: 5.63,
    height: 5.63,
    rx: 1.57,
    ry: 1.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "events-black_svg__cls-2",
    x: 5.62,
    y: 22.01,
    width: 5.63,
    height: 5.63,
    rx: 1.57,
    ry: 1.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "events-black_svg__cls-1",
    x: 10.05,
    y: 2.48,
    width: 2.98,
    height: 5.63,
    rx: 0.7,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "events-black_svg__cls-1",
    x: 21.67,
    y: 2.15,
    width: 2.98,
    height: 5.63,
    rx: 0.7,
    ry: 0.7
  }))));
};
export default SvgEventsBlack;